import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Grid, makeStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Edit from '@material-ui/icons/Edit';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import { handleSnackBar } from '../../../store/global/actions';
import { getInnerScreenRender } from '../../../store/global/selectors';
import { constructIds } from '../../../config/common';
import { tableTdIconStyles1 } from '../../../config/styles';
import { StyledTableCell, StyledTableCellHead, StyledTableRow } from '../../atoms/table/tableStyles';
import Hyperlink from '../../atoms/links/Hyperlink';
import Strip from '../../atoms/Wrappers/Strip';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { SearchTextField } from '../blueprint/SearchField';
import { userTriggersOfEvent, getUserTriggersOfDelegate } from '../../../services/entities/user_triggers';
import { invokePostService, invokeGetService, setInnerScreenRender, handleTopRightInfo } from "../../../store/global/actions";


const useStyles = makeStyles((theme) => ({
    tableCellPadding: {
        tableCellPadding: "0px 5px"
    }
}));

export default function ListUserTriggers({ setAction, element, setHideUserTrigCreateBtn }) {
    let userTriggers = [];
    const classes = useStyles();
    const dispatch = useDispatch();
    const [clusterlets, setClusterlets] = useState([])
    const [userTriggersOfSelectedEvent, setUserTriggersOfSelectedEvent] = useState([])
    const [userTriggersOfSelectedDelegate, setUserTriggersOfSelectedDelegate] = useState([]);
    const [allUserTriggers, setAllUserTriggers] = useState([])
    const innerScreenRender = useSelector(getInnerScreenRender);
    const [showCreate, setShowCreate] = useState(true)


    const [randNumber, setRandNumber] = React.useState(0);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [filtered, setFiltered] = useState((element.type === constructIds.find(item => item.type === "external_function").id) ? userTriggersOfSelectedDelegate : (element.type === constructIds.find(item => item.type === "events").id) ? userTriggersOfSelectedEvent : allUserTriggers);

    useEffect(() => {
        setLoading(true);
        dispatch(invokeGetService('getUserTriggerList', []))
            .then((response) => {
                if (response.data !== undefined) {
                    setClusterlets(response.data.clusterlets)
                    
                    const eventUserTriggers = userTriggersOfEvent({ event: element.id, constructs: response.data })
                    setUserTriggersOfSelectedEvent(eventUserTriggers);
                    setUserTriggersOfSelectedDelegate(getUserTriggersOfDelegate({ delegate: element.id, constructs: response.data }))
                    setAllUserTriggers(response.data.userTriggers);

                    // To hide the craete user trigger btn from the tab if usertrigger already exist for the event
                    if(setShowCreate){
                        setShowCreate(!(eventUserTriggers && eventUserTriggers?.length > 0));
                    }

                    if (element.type === "external_function") {
                        setFiltered(getUserTriggersOfDelegate({ delegate: element.id, constructs: response.data }));
                        console.log("Uts-----------", getUserTriggersOfDelegate({ delegate: element.id, constructs: response.data }))
                    }

                    if (element.type === constructIds.find(item => item.type === "events").id) {
                        setFiltered(userTriggersOfEvent({ event: element.id, constructs: response.data }));
                    }

                    if (element.subType && "controller") {
                        setFiltered(filterArray(response.data.userTriggers))
                    }
                }
                setLoading(false);
            })

    
        

    }, [innerScreenRender])

    useEffect(() => {
        if (element.type === "external_function") {
            setFiltered(filterArray(userTriggersOfSelectedDelegate))
        }

        if (element.type === constructIds.find(item => item.type === "events").id) {
            setFiltered(filterArray(userTriggersOfSelectedEvent))
        }

        if (element.subType && "controller") {
            setFiltered(filterArray(allUserTriggers))
        }

    }, [searchQuery, randNumber])


    if (element.type === "external_function") {
        element.tag = "external_function"
        userTriggers = userTriggersOfSelectedDelegate;
    }

    if (element.type === constructIds.find(item => item.type === "events").id) {

        element.tag = "event"
        userTriggers = userTriggersOfSelectedEvent;
    }

    if (element.subType && element.subType === 'controller') {
        element.tag = "external_function"
        userTriggers = allUserTriggers;
    }

    const filterArray = (array) => {
        return array.filter(row => (
            (row.attributes.desc !== undefined ? row.attributes.desc : '').toLowerCase().includes(searchQuery.toLowerCase())
            || (row.transaction?.name != undefined ? row.transaction?.name : '').toLowerCase().includes(searchQuery.toLowerCase())
            || (row.event.name != undefined ? row.event.name : '').toLowerCase().includes(searchQuery.toLowerCase())
            || (clusterlets.find(e => e._id === row.event.dst)?.name).toLowerCase().includes(searchQuery.toLowerCase())
        ))

    }

    const moveSectionUp = (userTriggerId) => {
        const parent = {
            id: element.id,
            tag: "external_function"
        }
        dispatch(handleTopRightInfo({ message: "Moving user trigger..", open: true, }));
        // dispatch(moveOneUserTriggerUpDown(userTriggerId, parent, 'up'))
        dispatch(invokePostService('moveUserTrigger', { direction: 'up', parent }, [userTriggerId])).then(res => {
            dispatch(handleTopRightInfo({ open: false }));
            if (res?.status) {
                dispatch(setInnerScreenRender())
                dispatch(handleSnackBar({ open: true, message: "User Trigger moved", severity: "success" }));
                // setAction({});
            } else {
                if (res?.code === 255) {
                    // setAction({});
                }
            }
        });
        setSearchQuery('')
        upateRandom()
    }

    const moveSectionDown = (userTriggerId) => {
        const parent = {
            id: element.id,
            tag: "external_function"
        }
        dispatch(handleTopRightInfo({ message: "Moving user trigger..", open: true, }));
        dispatch(invokePostService('moveUserTrigger', { direction: 'down', parent }, [userTriggerId])).then(res => {
            dispatch(handleTopRightInfo({ open: false }));
            if (res?.status) {
                dispatch(setInnerScreenRender())
                dispatch(handleSnackBar({ open: true, message: "User Trigger moved", severity: "success" }));
                // setAction({});
            } else {
                if (res?.code === 255) {
                    // setAction({});
                }
            }
        });
        // dispatch(moveOneUserTriggerUpDown(userTriggerId, parent, 'down'))
        setSearchQuery('')
        upateRandom()
    }

    const upateRandom = () => {
        let x = Math.random() * 100;
        setRandNumber(x);
    }

    const sortArrowStyle = {
        fontSize: 22,
        margin: 'auto',
        color: '#4791db',
        cursor: 'pointer',
        marginTop: 3,
        marginRight: 10,
    }
    return (
        <>
            {
                showCreate &&
                <Grid justify='flex-end' style={{display: 'flex'}}>
                    <Tooltip title={filtered.length >= 1 ? 'User trigger exits' : 'Create user trigger'}>
                    <span>
                      <Button 
                        disabled={filtered.length >= 1} 
                        onClick={(e) => setAction({ action: 'create_user_trigger' })} 
                        color="primary" variant="contained" 
                        style={{textTransform: 'capitalize',  marginLeft: 10, marginBottom: 10
                    }}>
                        Create user trigger
                      </Button>
                    </span>
                    </Tooltip>
                </Grid>
            }
            <TableContainer component={Paper} style={{borderRadius: 0, boxShadow: 'none'}}>
                <Table aria-label="customized table" id="user_trigger_table">

                    <TableHead>
                        <TableRow>
                            {/* <StyledTableCell align='center'>Name</StyledTableCell> */}
                            <StyledTableCellHead align='left'>Description</StyledTableCellHead>
                            {element.tag === "external_function" && <StyledTableCellHead align='left'>Transaction</StyledTableCellHead>}
                            {element.tag === "external_function" && <StyledTableCellHead align='left'>Event Name</StyledTableCellHead>}
                            <StyledTableCellHead align='left'>Clusterlet</StyledTableCellHead>
                            {/* <StyledTableCellHead align='center'>Instance</StyledTableCellHead> */}
                            {/* <StyledTableCellHead align='center'>Instance Description</StyledTableCellHead> */}
                            <StyledTableCellHead align='center'>Fields</StyledTableCellHead>
                            <StyledTableCellHead align='right' >Actions</StyledTableCellHead>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {loading ?
                            <StyledTableRow>
                                <StyledTableCell align={'center'} colSpan={7} component="td" style={{ padding: 15 }}>
                                    Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                </StyledTableCell>
                            </StyledTableRow>
                            : filtered.length < 1 ?
                                <StyledTableRow>
                                    <StyledTableCell align={'center'} colSpan={6} component="td" style={{ padding: 15 }}>
                                        No user triggers available.
                                    </StyledTableCell>
                                </StyledTableRow>
                                :

                                filtered?.map((userTrigger, index) => (

                                    <StyledTableRow key={userTrigger._id} >

                                        {/* <StyledTableCell align={'center'} component="td" width='10%'>
                                    {userTrigger.name}
                                </StyledTableCell> */}

                                        <Tooltip title={userTrigger.attributes.desc} width='70%'>
                                            <StyledTableCell align={'left'} component="td" className={classes.tableCellPadding} >
                                                <Strip length={30}>{userTrigger.attributes.desc}</Strip>
                                            </StyledTableCell>
                                        </Tooltip>

                                        {element.tag === "external_function" && <StyledTableCell align={'left'} component="td" className={classes.tableCellPadding} width='50%'>
                                            {/* <Hyperlink id={userTrigger.transaction._id} type={constructIds.find(item => item.id === userTrigger.transaction.type).type} screen={'information_flow'}> {userTrigger.transaction.name} </Hyperlink> */}
                                            <Hyperlink id={userTrigger?.transaction?._id} name={userTrigger?.transaction?.name} transactionId={userTrigger?.transaction?._id} type={'transaction'} screen={'transaction'}> {userTrigger?.transaction?.name} </Hyperlink>
                                        </StyledTableCell>}

                                        {element.tag === "external_function" && <StyledTableCell align={'left'} component="td" className={classes.tableCellPadding} width='50%'>
                                            {/* <Hyperlink id={userTrigger.event._id} type='event' screen={'information_flow'}> {userTrigger.event.name} </Hyperlink> */}
                                            <Hyperlink id={userTrigger?.event?._id} item={userTrigger?.event} name={userTrigger?.event?.name} transactionId={userTrigger?.transaction?._id} type={'event'} screen={'transaction'}> {userTrigger?.event?.name} </Hyperlink>

                                        </StyledTableCell>}

                                        <StyledTableCell align={'left'} component="td" className={classes.tableCellPadding} width='70%'>
                                            <Hyperlink id={userTrigger.event.dst} type={constructIds.find(item => item.id == clusterlets.find(item => item._id == userTrigger.event.dst)?.type)?.type} > {clusterlets.find(e => e._id == userTrigger.event.dst)?.name} </Hyperlink>
                                        </StyledTableCell>

                                        {/* <StyledTableCell align={'center'} component="td" width='10%'>
                                    {userTrigger.field?.name}
                                </StyledTableCell> */}

                                        {/* <StyledTableCell align={'center'} component="td" >                  
                                    {userTrigger.field?.attributes?.desc? userTrigger.field?.attributes?.desc :""}
                                    </StyledTableCell>   
                                */}


                                        <Tooltip title={"Edit field values"} width='50%'>
                                            <StyledTableCell align='center' component="td" className={classes.tableCellPadding}>
                                                <IconButton aria-label="more" size="small" aria-haspopup="true" onClick={() => setAction({ action: 'extend_fields', id: userTrigger._id })}>
                                                    <AddBoxIcon color='primary' />
                                                </IconButton>
                                            </StyledTableCell>
                                        </Tooltip>

                                        <StyledTableCell align="right" className={classes.tableCellPadding} style={{ minWidth: filtered.length > 1 ? 200 : 150 }}>

                                            {element.type === 'external_function' && <>
                                                {index > 0 && searchQuery.length === 0 && < Tooltip title="Move position up">
                                                    {/* <IconButton> */}
                                                    <ArrowUpwardIcon onClick={e => moveSectionUp(userTrigger._id)} style={sortArrowStyle} />
                                                    {/* </IconButton> */}
                                                </Tooltip>}


                                                {userTriggers.length - 1 !== index && searchQuery.length === 0 && <Tooltip title="Move position down">
                                                    {/* <IconButton> */}
                                                    <ArrowDownwardIcon onClick={e => moveSectionDown(userTrigger._id)} style={sortArrowStyle} />
                                                    {/* </IconButton> */}
                                                </Tooltip>}
                                            </>}



                                            <Tooltip title="Edit user trigger">
                                                {/* <IconButton aria-label="more" aria-haspopup="true" onClick={() => setAction({ action: 'edit_user_trigger', id: userTrigger.id, item: userTrigger })}> */}
                                                <Edit color="primary" style={tableTdIconStyles1} onClick={() => setAction({ action: 'edit_user_trigger', id: userTrigger._id, item: userTrigger })} />
                                                {/* </IconButton> */}
                                            </Tooltip>

                                            <Tooltip title="Delete user trigger">
                                                {/* <IconButton aria-label="more" aria-haspopup="true" onClick={() => setAction({ action: 'delete_user_trigger', id: userTrigger.id, item: userTrigger })}> */}
                                                <DeleteIcon color="error" style={tableTdIconStyles1} onClick={() => setAction({ action: 'delete_user_trigger', id: userTrigger._id, item: userTrigger })} />
                                                {/* </IconButton> */}
                                            </Tooltip>

                                        </StyledTableCell>

                                    </StyledTableRow>
                                ))}
                    </TableBody>

                </Table>
            </TableContainer>
        </>
    )
}
